// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7JH44","colBig":"styles_colBig__27IdA","colSmall":"styles_colSmall__Q0wU5","shopifyNameWrapper":"styles_shopifyNameWrapper__3G4Uo"};